<script setup lang="ts">
// Footer component matching the Blade design
</script>

<template>
  <footer class="main-footer">
    <div class="footerCopyRightNavRow mt-5">
      <div class="container">
        <div class="row">
          <!-- Bangladesh Office -->
          <div class="col-lg-8 col-md-12 mb-3 office-info">
            <strong>Bangladesh Office:</strong>
            <p>2nd floor, Ka-24/4, Sarkar Market (Opposite of Syed Ali Super Market),<br>
              Bashundhara R/A Main Gate, Dhaka-1229</p>

            <strong>Thailand Liaison Office:</strong>
            <p>The Trendy Office Building, Ground Floor,<br>
              Soi Sukhumvit 13, Khlong Toei Nuea, Bangkok 10110</p>

            <strong>India Liaison Office:</strong>
            <p>38, Patel Road, Pradhan Nagar, Siliguri West Bengal-734003</p>
          </div>

          <!-- Support Section -->
          <div class="col-lg-4 col-md-12 d-flex mb-3 support-section">
            <div>
              <p><strong>For Support:</strong></p>
              <hr>
              <p>+8801716436241, +8801951144402, +8801951144410</p>
              <p>info@b2btourdeal.com</p>
              <ul class="list-unstyled">
                <li>
                  <a class="whatsapp-link" href="https://chat.whatsapp.com/J0Qcxot6defA2Vf145eh4K" target="_blank">
                    <i class="fab fa-whatsapp"></i> Join Whatsapp Group
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr>
        <p class="concern-text">A Concern Of Trip Tricks</p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
@import url("./AppFooter.css");
</style>

